import { render, staticRenderFns } from "./IssueStatusSelect.vue?vue&type=template&id=e46b28d0&scoped=true&"
import script from "./IssueStatusSelect.vue?vue&type=script&lang=ts&"
export * from "./IssueStatusSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46b28d0",
  null
  
)

export default component.exports